import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import { RootLayout } from '@/components/layout/RootLayout';
import { AdminsPage } from '@/pages/Admins';
import { DashboardPage } from '@/pages/Dashboard';
import { LoginPage } from '@/pages/Login';
import { ModulesPage } from '@/pages/Modules';
import { NotFoundPage } from '@/pages/NotFound';
import { AuditLogPage } from '@/pages/settings/AuditLogPage';
import { ServerPage } from '@/pages/settings/ServerPage';
import { CategoriesPage } from '@/pages/tickets/CategoriesPage';
import { CategoryDetailPage } from '@/pages/tickets/CategoryDetailPage';
import { PanelDetailPage } from '@/pages/tickets/PanelDetailPage';
import { PanelsPage } from '@/pages/tickets/PanelsPage';
import { TicketDetailPage } from '@/pages/tickets/TicketDetailPage';
import { TicketsListPage } from '@/pages/tickets/TicketsListPage';
import { AnnouncementsListPage } from '@/pages/announcements/AnnouncementsListPage';
import { AnnouncementDetailPage } from '@/pages/announcements/AnnouncementDetailPage';
import { GiveawaysListPage } from '@/pages/giveaways/GiveawaysListPage';
import { GiveawayDetailPage } from '@/pages/giveaways/GiveawayDetailPage';
import { RolesListPage } from '@/pages/roles/RolesListPage';
import { RoleRuleDetailPage } from '@/pages/roles/RoleRuleDetailPage';
import { UserDetailPage } from '@/pages/users/UserDetailPage';
import { UsersListPage } from '@/pages/users/UsersListPage';

const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    path: '/',
    element: <RootLayout />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'tickets', element: <TicketsListPage /> },
      { path: 'tickets/:id', element: <TicketDetailPage /> },
      { path: 'tickets/categories', element: <CategoriesPage /> },
      { path: 'tickets/categories/:id', element: <CategoryDetailPage /> },
      { path: 'tickets/panels', element: <PanelsPage /> },
      { path: 'tickets/panels/:id', element: <PanelDetailPage /> },
      { path: 'announcements', element: <AnnouncementsListPage /> },
      { path: 'announcements/:id', element: <AnnouncementDetailPage /> },
      { path: 'giveaways', element: <GiveawaysListPage /> },
      { path: 'giveaways/:id', element: <GiveawayDetailPage /> },
      { path: 'roles', element: <RolesListPage /> },
      { path: 'roles/:id', element: <RoleRuleDetailPage /> },
      { path: 'users', element: <UsersListPage /> },
      { path: 'users/:discordId', element: <UserDetailPage /> },
      { path: 'settings/server', element: <ServerPage /> },
      { path: 'settings/audit', element: <AuditLogPage /> },
      { path: 'settings/admins', element: <AdminsPage /> },
      { path: 'settings/modules', element: <ModulesPage /> },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}

export { NotFoundPage };
